import styled from "styled-components";
import { Button, Modal } from "../../global";

const EndButtons = styled(Button)`
  width: 20%;
  min-width: 75px;
`;

const EndContainer = styled(Modal)`
  gap: 10px;
  justify-content: center;
  transform: ${(props) =>
    props.$winner === "Red wins!" ? "rotate(180deg)" : "none"};
`;

export { EndButtons, EndContainer };
